import { useEffect } from 'react';
import { usePageVisit, trackAffiliateClick } from '../../hooks/useAnalytics';

export default function ThankYouPage() {
  // Track thank you page visit
  usePageVisit('thank-you');

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  const handleNobleGoldClick = async () => {
    // Track affiliate click before opening link
    await trackAffiliateClick();
    
    // Open Noble Gold link
    window.open('https://www.noblegoldinvestments.com/Epic', '_blank', 'noopener,noreferrer');
  };

  const handleDownloadPDF = () => {
    // Trigger PDF download
    window.open('https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/2a6cc4d425cb09463763de866c7e3b61.png', '_blank');
  };

  return (
    <div className="bg-[#0A1628] text-white min-h-screen" style={{fontFamily: 'Montserrat, sans-serif'}}>
      {/* Success Status Bar */}
      <div className="bg-[#00FF00]/20 border-b-2 border-[#00FF00] py-4 md:py-5">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 flex items-center justify-center gap-3 md:gap-4">
          <div className="w-4 h-4 md:w-5 md:h-5 bg-[#00FF00] rounded-full flex items-center justify-center">
            <i className="ri-check-line text-[#0A1628] text-sm md:text-base font-bold"></i>
          </div>
          <p className="text-[13px] sm:text-[15px] md:text-[17px] font-mono tracking-wider text-[#00FF00] font-bold">
            ✅ PROTOCOL SENT TO YOUR INBOX // CHECK YOUR EMAIL
          </p>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        {/* Dark Background */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/9e00ad13bff661807fc2530b9aae11d5.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <div className="absolute inset-0 bg-black/90"></div>
        </div>

        <div className="relative z-10 max-w-[1000px] mx-auto px-4 md:px-6 text-center">
          {/* Main Headline */}
          <h1 className="text-[36px] sm:text-[48px] md:text-[64px] lg:text-[72px] font-black text-white mb-4 md:mb-6 leading-[1.1]" style={{fontFamily: 'Oswald, sans-serif'}}>
            PROTOCOL SENT.<br/>
            <span className="text-[#D4AF37]">NOW, MEET THE WINNER.</span>
          </h1>

          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-8 md:mb-12"></div>

          {/* The Story */}
          <div className="space-y-6 md:space-y-8 text-left max-w-[800px] mx-auto">
            <p className="text-[15px] md:text-[18px] text-white/90 leading-[1.8]">
              I didn't just write the Interrogation Script.
            </p>
            
            <p className="text-[15px] md:text-[18px] text-white/90 leading-[1.8]">
              <strong className="text-[#00FF00]">I used it.</strong>
            </p>

            <p className="text-[15px] md:text-[18px] text-white/90 leading-[1.8]">
              I secret-shopped the <strong className="text-[#D4AF37]">top 12 Gold Dealers in America</strong>.
            </p>

            <div className="bg-[#FF0000]/10 border-l-4 border-[#FF0000] rounded-lg p-6 md:p-8">
              <p className="text-[15px] md:text-[18px] text-white/90 leading-[1.8] mb-4">
                <strong className="text-[#FF0000]">Most failed.</strong>
              </p>
              <ul className="space-y-3 text-[14px] md:text-[16px] text-white/80">
                <li className="flex items-start gap-3">
                  <span className="text-[#FF0000] flex-shrink-0">❌</span>
                  <span>They pushed high premiums (30-50% over spot)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#FF0000] flex-shrink-0">❌</span>
                  <span>They used confusing fees and hidden spreads</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#FF0000] flex-shrink-0">❌</span>
                  <span>They deployed fear tactics about government confiscation</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#00FF00]/10 border-l-4 border-[#00FF00] rounded-lg p-6 md:p-8">
              <p className="text-[15px] md:text-[18px] text-white/90 leading-[1.8] mb-4">
                <strong className="text-[#00FF00]">Only one passed the test.</strong>
              </p>
              <ul className="space-y-3 text-[14px] md:text-[16px] text-white/80">
                <li className="flex items-start gap-3">
                  <span className="text-[#00FF00] flex-shrink-0">✅</span>
                  <span>Fair bullion pricing (3-5% over spot)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#00FF00] flex-shrink-0">✅</span>
                  <span>Zero high-pressure sales tactics</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#00FF00] flex-shrink-0">✅</span>
                  <span>Streamlined IRA rollover process</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#00FF00] flex-shrink-0">✅</span>
                  <span>Transparent answers to all 10 questions</span>
                </li>
              </ul>
            </div>

            <p className="text-[16px] md:text-[20px] text-white font-semibold leading-[1.8] text-center pt-4">
              If you want to skip the interrogation and go straight to the source I trust:
            </p>
          </div>
        </div>
      </section>

      {/* The Winner Card */}
      <section className="relative py-12 md:py-16 bg-[#1A1A1A]">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <div className="bg-gradient-to-br from-[#D4AF37]/20 to-[#FFD700]/10 border-2 border-[#D4AF37] rounded-lg p-8 md:p-12 text-center">
            {/* Winner Badge */}
            <div className="inline-flex items-center gap-3 bg-[#D4AF37] px-6 py-3 rounded-full mb-6">
              <i className="ri-trophy-line text-2xl text-[#1A1A1A]"></i>
              <span className="text-[14px] md:text-[16px] font-black text-[#1A1A1A] tracking-wider" style={{fontFamily: 'Oswald, sans-serif'}}>
                THE WINNER
              </span>
            </div>

            <h2 className="text-[28px] md:text-[40px] font-black text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
              NOBLE GOLD INVESTMENTS
            </h2>

            <p className="text-[14px] md:text-[16px] text-white/80 mb-8 leading-[1.7] max-w-[600px] mx-auto">
              The only dealer who answered all 10 questions correctly, transparently, and without pressure. They focus on education, safe storage, and fair pricing.
            </p>

            {/* Primary CTA */}
            <button
              onClick={handleNobleGoldClick}
              className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] hover:from-[#FFD700] hover:to-[#D4AF37] text-[#1A1A1A] px-10 md:px-16 py-5 md:py-6 rounded-lg text-[16px] md:text-[20px] font-black transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3 mb-6"
              style={{fontFamily: 'Oswald, sans-serif'}}
            >
              <i className="ri-shield-star-line text-2xl"></i>
              GET THE NOBLE GOLD GUIDE
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>

            <p className="text-[12px] md:text-[14px] text-white/60 mb-8">
              Free Wealth Protection Guide • IRA Rollovers &amp; Physical Delivery
            </p>

            {/* Divider */}
            <div className="flex items-center gap-4 my-8">
              <div className="flex-1 h-px bg-white/20"></div>
              <span className="text-[12px] text-white/40 uppercase tracking-wider">or</span>
              <div className="flex-1 h-px bg-white/20"></div>
            </div>

            {/* Secondary CTA */}
            <button
              onClick={handleDownloadPDF}
              className="text-[13px] md:text-[14px] text-white/60 hover:text-white/90 transition-colors cursor-pointer underline"
            >
              No thanks, I'll find my own dealer using the script
            </button>
          </div>
        </div>
      </section>

      {/* Why Noble Gold Section */}
      <section className="relative py-16 md:py-24 bg-[#0A1628]">
        <div className="max-w-[1000px] mx-auto px-4 md:px-6">
          <h2 className="text-[28px] md:text-[40px] font-black text-white text-center mb-12 md:mb-16" style={{fontFamily: 'Oswald, sans-serif'}}>
            WHY NOBLE GOLD<br/>
            <span className="text-[#D4AF37]">PASSED THE TEST</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {/* Feature 1 */}
            <div className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-6 md:p-8 hover:border-[#D4AF37] transition-all duration-300">
              <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-price-tag-3-line text-2xl text-[#1A1A1A]"></i>
              </div>
              <h3 className="text-[18px] md:text-[20px] font-bold text-white mb-3" style={{fontFamily: 'Oswald, sans-serif'}}>
                TRANSPARENT PRICING
              </h3>
              <p className="text-[14px] text-white/70 leading-[1.7]">
                They clearly disclose premiums, spreads, and fees. No hidden costs. No surprise charges.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-6 md:p-8 hover:border-[#D4AF37] transition-all duration-300">
              <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl text-[#1A1A1A]"></i>
              </div>
              <h3 className="text-[18px] md:text-[20px] font-bold text-white mb-3" style={{fontFamily: 'Oswald, sans-serif'}}>
                EDUCATION FIRST
              </h3>
              <p className="text-[14px] text-white/70 leading-[1.7]">
                They teach you how gold works before selling you anything. No fear tactics or pressure.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-6 md:p-8 hover:border-[#D4AF37] transition-all duration-300">
              <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-safe-2-line text-2xl text-[#1A1A1A]"></i>
              </div>
              <h3 className="text-[18px] md:text-[20px] font-bold text-white mb-3" style={{fontFamily: 'Oswald, sans-serif'}}>
                SECURE STORAGE
              </h3>
              <p className="text-[14px] text-white/70 leading-[1.7]">
                IRA-approved depositories with full insurance. Or direct delivery to your door.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="relative py-16 md:py-20 bg-gradient-to-b from-[#1A1A1A] to-[#0A1628]">
        <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-[28px] md:text-[40px] font-black text-white mb-6" style={{fontFamily: 'Oswald, sans-serif'}}>
            YOU HAVE THE WEAPON.<br/>
            <span className="text-[#D4AF37]">NOW GET THE GOLD.</span>
          </h2>

          <p className="text-[15px] md:text-[18px] text-white/80 mb-10 leading-[1.8]">
            Use the Interrogation Protocol on any dealer you want. Or save time and start with the one who already passed.
          </p>

          <button
            onClick={handleNobleGoldClick}
            className="bg-[#00FF00] hover:bg-[#00DD00] text-[#1A1A1A] px-10 md:px-14 py-5 md:py-6 rounded-lg text-[16px] md:text-[18px] font-black transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
            style={{fontFamily: 'Oswald, sans-serif'}}
          >
            <i className="ri-shield-star-line text-2xl"></i>
            START WITH NOBLE GOLD
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>

          <p className="text-[12px] md:text-[13px] text-white/50 mt-6">
            Minimum investment applies • A+ BBB Rating • Thousands of 5-Star Reviews
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] border-t border-[#D4AF37]/20 py-8 md:py-12">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            <div className="flex items-center gap-3 md:gap-4">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/031439dfb7c5b3457d1186c629c535e0.png" 
                alt="Shield Logo"
                className="h-8 w-8 md:h-10 md:w-10 object-contain"
              />
              <p className="text-xs text-white/70">Epic Real Estate</p>
            </div>

            <div className="flex items-center gap-4 md:gap-8">
              <a href="/" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap cursor-pointer">
                Back to Main Site
              </a>
              <a href="/privacy-policy" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap cursor-pointer">
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap cursor-pointer">
                Terms &amp; Conditions
              </a>
            </div>
          </div>

          <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-white/10 text-center">
            <p className="text-[10px] md:text-xs text-white/50">
              © 2026 Epic Real Estate. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}